import {
    TRAININGS_FETCHING,
    TRAININGS_FAILED,
    TRAININGS_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case TRAININGS_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case TRAININGS_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case TRAININGS_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
};
